<template>
  <gj-image
      :src="row.imageUrl"
      tag-color="rgb(246 144 10)"
      :tag="groupType === 'variationAsin' && !row.nonVariationAsin ? '变' : null">
  </gj-image>
</template>

<script>
  export default {
    name: "app-dashboard-rank-picture-column",
    props: {
      row: {
        required: true
      },
      groupType: {
        required: true
      }
    }
  }
</script>

<style scoped>

</style>
